import de from '@translations/de/changeProfileNamePopup.json';
import en from '@translations/en/changeProfileNamePopup.json';
import pl from '@translations/pl/changeProfileNamePopup.json';
import sl from '@translations/sl/changeProfileNamePopup.json';
import uk from '@translations/uk/changeProfileNamePopup.json';
import bg from '@translations/bg/changeProfileNamePopup.json';
import cz from '@translations/cz/changeProfileNamePopup.json';
import fr from '@translations/fr/changeProfileNamePopup.json';
import gr from '@translations/gr/changeProfileNamePopup.json';
import it from '@translations/it/changeProfileNamePopup.json';
import pr from '@translations/pr/changeProfileNamePopup.json';
import ru from '@translations/ru/changeProfileNamePopup.json';
import sk from '@translations/sk/changeProfileNamePopup.json';
import sp from '@translations/sp/changeProfileNamePopup.json';
import tr from '@translations/tr/changeProfileNamePopup.json';
import hu from '@translations/hu/changeProfileNamePopup.json';
import { ITranslations } from '@/types/common';
import { ChangeProfileNamePopupTransFields } from './types';

export const changeProfileNamePopupTranslations: ITranslations<ChangeProfileNamePopupTransFields> =
  {
    name: 'changeProfileNamePopup',
    de,
    en,
    pl,
    sl,
    uk,
    bg,
    cz,
    fr,
    gr,
    it,
    pr,
    ru,
    sk,
    sp,
    tr,
    hu,
  };
